import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Tyrehistory_view = () => {
  useAuthRedirect();
  const { id } = useParams(); 
  // const [vehicleResult, setVehicle] = useState([]);
  const branch = localStorage.getItem("branch"); // Default branch from storage
  const navigate = useNavigate();
  const [header, setHeader] = useState({});
  const [totalCombined, setTotalCombined] = useState(0);
const [totKm, setTotKm] = useState(0);
const [totHr, setTotHr] = useState(0);
const [vehicleBasis, setVehicleBasis] = useState("");
const [cum, setCum] = useState("");

const [cumulativeList, setCumulativeList] = useState([]);
const [vehicle, setVehicle] = useState([]);

 const canView  = hasPermission("Tyre Maitenance Report", "view");


 useEffect(() => {
  const fetchTyreStatusWithProgress = async () => {
    let progress = 0;

    const updateProgress = (val) => {
      const bar = document.getElementById("progress-bar");
      const text = document.getElementById("progress-text");
      if (bar) bar.style.width = `${val}%`;
      if (text) text.innerText = `Loading... ${val}%`;
    };

    Swal.fire({
      title: "Fetching Tyre Details",
      html: `
        <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
        </div>
        <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => updateProgress(0),
    });

    try {
      // 1. Fetch Vehicle Bottom Details
      const response1 = await axios.get(`https://rfs2.infraconsoft.net.in/api/tyreCurrentStatus_bottomDetails/${id}`);
      const vehicles = response1.data.vehicles;
      setVehicle(vehicles);
      progress = 30;
      updateProgress(progress);

      const uniqueVehicleCodes = [
        ...new Set(
          vehicles
            .map((v) => v.tyre_vehicle)
            .filter((vcode) => vcode !== null && vcode !== "")
        ),
      ];

      const cumulativeData = [];

      for (let i = 0; i < uniqueVehicleCodes.length; i++) {
        const vcode = uniqueVehicleCodes[i];
        try {
          const res = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_TyreMain_cumulative_api?vcode=${vcode}`);
          const data = res.data?.cumulativeHrs?.[0];
          if (data) {
            cumulativeData.push({
              vcode,
              tot_km: data.tot_km || 0,
              total_combined: data.total_combined || 0,
              basis: data.vehicle_basis || "",
            });
          }
        } catch (error) {
          console.error(`Error fetching cumulative for ${vcode}:`, error);
        }
      }

      setCumulativeList(cumulativeData);
      progress = 60;
      updateProgress(progress);

      // 2. Fetch Header Details
      const response2 = await axios.get(`https://rfs2.infraconsoft.net.in/api/tyreCurrentStatus_headerDetails?id=${id}&branch=${branch}`);
      if (response2.data && response2.data.headerDetails?.length > 0) {
        const item = response2.data.headerDetails[0];
        setHeader({
          tyre_model: item.tyre_model || "N/A",
          vehicle_name: item.vehicle_name || "N/A",
          tyre_amount: item.tyre_amount || "N/A",
          tyre_make: item.tyre_make || "N/A",
          tyre_seriolno: item.tyre_seriolno || "N/A",
          tyre_type: item.tyre_type || "N/A",
        });
      }

      progress = 85;
      updateProgress(progress);

      // 3. Fetch Remove History
      const response3 = await axios.get(`https://rfs2.infraconsoft.net.in/api/tyreHistory_data_remove?id=${id}`);
      if (response3.data && response3.data.tyreHistory?.length > 0) {
        const item = response3.data.tyreHistory[0];
        setCum({
          remove_date: item.remove_date || "N/A",
          remove_km: item.remove_km || "N/A",
        });
      }

      progress = 100;
      updateProgress(progress);

      setTimeout(() => Swal.close(), 300); // Close progress bar
    } catch (error) {
      console.error("Error fetching tyre data:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to Fetch",
        text: "There was a problem fetching tyre details.",
      });
    }
  };

  if (id && branch) {
    {canView && (
    fetchTyreStatusWithProgress()
    )}
  }
}, [id, branch]);

 if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
          
                     <div className="back-div">
                                          <h2 className="add-txt">Tyre History View</h2>
                                          <Link to={`/tyreHistory`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
                                          </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>Tyre(Front/Rear) :</label>
                <input type="text" name="tyre_type" value={header.tyre_type} readOnly/>

              </div>
              <div className="form-group">
                <label>Serial No :</label>
                <input type="text" name="tyre_seriolno" value={header.tyre_seriolno} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Model :</label>
                <input type="text" name="tyre_model" value={header.tyre_model} readOnly />
              </div>
              <div className="form-group">
                <label>Make :</label>
                <input type="text" name="tyre_make" value={header.tyre_make} readOnly />
              </div>
            </div> 

             <div className="form-row">
            <div className="form-group">
                <label>Rate(New) :</label>
                <input type="text" name="tyre_amount" value={header.tyre_amount} readOnly />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden"  />
              </div>
            </div>           
            
            <div className="content-table">
            <table>
  <thead>
    <tr>
      <th>S.No</th>
      <th>Equ.Name</th>
      <th>Branch</th>
      <th>Original/RTD</th>
      <th>Fitting Date</th>
      <th>Fitting Hrs/Km</th>
      <th>Removing Date</th>
      <th>Removing Km/Hrs</th>
      <th>Running Km/Hrs</th>
      <th>Rate</th>
      <th>Tyre Cost Km/Hrs</th>
      <th>Remarks</th>
    </tr>
  </thead>
  <tbody>
  {vehicle.map((item, index) => {
  const cum = cumulativeList.find(
    (c) =>
      c.vcode.trim().toLowerCase() === (item.tyre_vehicle || "").trim().toLowerCase()
  );

  return (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>{item.tyre_vehicle}</td>
      <td>{item.tyre_branch}</td>
      <td>{item.tyre_type}</td>
      <td>{new Date(item.fitting_date).toLocaleDateString("en-GB")}</td>
      <td>{item.fitting_km}</td>

      {item.tyre_removeflag === 0 ? (
        <td colSpan={2} style={{ color: "red", fontWeight: "bold" }}>
          Not yet removed
        </td>
      ) : (
        <>
          <td>{item.remove_date ? new Date(item.remove_date).toLocaleDateString("en-GB") : "—"}</td>
          <td>{item.remove_km ?? "—"}</td>
        </>
      )}

      <td>
        {cum
          ? cum.basis === "Hour"
            ? cum.total_combined.toFixed(2)
            : cum.tot_km.toFixed(2)
          : "—"}
      </td>

      <td>{item.tyre_amount}</td>
      <td>{item.tyre_amount}</td>
      <td>{item.tyre_remarks}</td>
    </tr>
  );
})}

</tbody>

</table>
            </div>
         
          </form>
          <div className="btn-cls">
                                  <Link to={`/tyreHistory_Print/${id}`} target="_blank">
                              <button className="add-new-btn">Print</button>
                            </Link>
                                  </div>
        </div>

      
      </div>
    </div>
  );
};

export default Tyrehistory_view;
